import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  TemplateRef,
  OnInit,
} from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import {NgIf, NgTemplateOutlet} from '@angular/common';
import {ShareButtonsModule} from 'ngx-sharebuttons/buttons';

@Component({
  selector: 'app-dialog',
  templateUrl: './dialog.component.html',
  styleUrls: ['./dialog.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgTemplateOutlet,
    ShareButtonsModule
  ]
})
export class DialogComponent implements OnInit {
  @Input() fullScreen: boolean = false;
  @Input() header: string = 'Dialog header';
  @Input() body: string = 'Dialog body';
  @Input() footer: string = 'Dialog footer';
  @Input() templateType: string = 'shareChartTemplate'; // Default template type
  @Output() closeDialog = new EventEmitter<void>();
  @Output() submitForm = new EventEmitter<{
    id: number;
    name: string;
    description: string;
  }>();

  @ViewChild('shareChartTemplate', { static: true })
  shareChartTemplate!: TemplateRef<any>;
  // @ViewChild('addNewList', { static: true }) addNewList!: TemplateRef<any>;

  buttons_to_include = ['linkedin', 'facebook', 'twitter', 'email', 'copy'];
  shareUrl = window.location.href;

  templates: { [key: string]: TemplateRef<any> } = {};

  formData = { id: 0, name: '', description: '' };

  constructor(private clipboard: Clipboard) {}

  ngOnInit() {
    this.templates = {
      shareChartTemplate: this.shareChartTemplate,
      // addNewList: this.addNewList,
    };
  }

  onSubmit() {
    this.submitForm.emit(this.formData);
  }

  destroyMe() {
    this.closeDialog.emit();
  }
}
